export default "__VITE_ASSET__R$Nx$lQ8__"